'use client';

import { RichTextEditor } from '@/components/commons/minimal-tiptap/minimal-tiptap';
import { BlogDetailTitleElementDataType } from '@/components/sections/builder/elements/body/blog-detail/type';
import { ElementProps } from '@/components/sections/builder/types';
import { useBlogsDetails } from '@/hooks/api/storefront/blogs';
import { useBuilderStore } from '@/stores/builder';
import { Type } from 'lucide-react';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { shallow } from 'zustand/shallow';

const defaultData = {
  name: 'Content',
  label:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque at pretium odio. Maecenas viverra tortor consequat, pulvinar felis nec, aliquam diam. Nulla rutrum diam eros, ac dignissim quam pulvinar quis. Aliquam libero metus, posuere vitae maximus ac, suscipit eget mauris. Donec mauris augue, mollis in aliquet sit amet, bibendum vitae sapien.',
};

export const ElementContent = ({ element }: ElementProps) => {
  const { slug } = useParams<{ slug: string }>();
  const { data, isLoading } = useBlogsDetails(slug);

  const parentData = (element?.parentData as BlogDetailTitleElementDataType) || element?.data || {};
  const colorScheme = parentData.colorSchemeSection;
  const textColor = (colorScheme?.text as string) || 'black';

  if (isLoading) {
    return null;
  }

  return (
    <>
      <div className='space-y-3 overflow-hidden text-justify'>
        <RichTextEditor
          content={data?.content || defaultData.label}
          editable={false}
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert force-color',
            },
          }}
        />

        <style jsx global>{`
          .force-color,
          .force-color strong {
            color: ${textColor} !important;
          }
        `}</style>
      </div>
    </>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting() {
  const { storeId } = useParams();

  const { item } = useBuilderStore(
    (state) => ({
      item: state.previewPageItem,
    }),
    shallow
  );

  return (
    <div>
      <div className='my-4'>
        This content is from your blog post.
        <span className='text-blue-500 underline'>
          <Link href={`/store/${storeId}/blog/blog-post/${item?.id}`}>Edit Blog Post</Link>
        </span>
      </div>
    </div>
  );
}

const BlogDetailContent = {
  type: 'content',
  group: 'blog_detail',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default BlogDetailContent;
